import auth from "./Authenticate.vue"

export default {
    name: "auth",
    component: auth,
    auth: false
}